import React from "react"
import autobind from "class-autobind"
import { IPunchBundle, IPunchResult, EPunchValidationType, IUIUser, ITimecardEmployee } from "../../../models"
import { IconButton } from "material-ui"
import GlobalPunchAddIcon from "../../../../assets/icons/global-punch-add"
import strings from "../../../localization/strings"
import * as permissionHelper from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import HierarchySettingsStore from "../../../stores/HierarchySettingsStore"
import AddPunchDialog from "../AddPunchDialog"
import * as punchHelper from "../../../helpers/punchHelper"
import * as punchActions from "../../../actions/PunchActions"
import AppStateStore from "../../../stores/AppStateStore"
import PunchResultDialog from "../punch_result/PunchResultDialog"
import moment from "moment"
interface IProps {
    style?: React.CSSProperties
    employees: ITimecardEmployee[]
    reloadPage?(): void
}
interface IState {
    openAddPunchDialog: boolean
    addResults: IPunchResult[]
}

export default class GlobalPunchAdd extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddPunchDialog: false,
            addResults: []
        }
        autobind(this)
    }

    handleAddGlobalPunch(punchBundle: IPunchBundle) {
        this.setState({ openAddPunchDialog: false })
        AppStateStore.setProgressSnackbarContent("loading")
        punchActions.addGlobalPunch(this.props.employees.map(i => i.Id), punchBundle).then((addResults: IPunchResult[]) => {
            this.setState({ addResults })
            AppStateStore.setProgressSnackbarContent(null)
        })
    }

    render() {
        if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Timecards.GlobalPunchAdd)) return null
        let defaultHierarchyId = HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
        if (this.state.openAddPunchDialog) {
            defaultHierarchyId = punchHelper.getDefaultGlobalPunchHierarchy(this.props.employees as IUIUser[])
        }

        return (
            <div style={this.props.style} >
                <IconButton
                    data-intercom-target={"Timecards-Btn-GlobalAddPunch"}
                    tooltip={strings.Global_Punch_Add}
                    iconStyle={{ width: 30, height: 30 }}
                    style={{ padding: 0, top: 2, height: 35 }}
                    onTouchTap={() => this.setState({ openAddPunchDialog: true })}
                >
                    <GlobalPunchAddIcon width={20} height={20} />
                </IconButton>
                {this.state.openAddPunchDialog &&
                    <AddPunchDialog
                        isPunchIn
                        pairedPunchId={null}
                        date={moment().utc(true).toDate()}
                        hierarchyId={defaultHierarchyId}
                        positionId={null}
                        payClassId={null}
                        payTypeId={null}
                        shiftId={null}
                        breakId={null}
                        mobileBreakId={null}
                        jobId={null}
                        phaseId={null}
                        equipmentId={null}
                        onRequestClose={() => this.setState({ openAddPunchDialog: false })}
                        user={null}
                        addPunch={null}
                        payrollHierarchyId={null}
                        payrollPayGroupId={null}
                        //global add punch
                        isGlobalPunch
                        globalPunchEmployees={this.props.employees}
                        handleAddGlobalPunch={this.handleAddGlobalPunch}
                    />
                }
                <PunchResultDialog
                    isGlobalPunch
                    globalPunchEmployees={this.props.employees}
                    results={this.state.addResults}
                    handleClose={() => {
                        this.props.reloadPage && this.state.addResults.filter(i => i.Type === EPunchValidationType.Valid).length &&
                            this.props.reloadPage()
                        this.setState({ addResults: [] })
                    }}
                />
            </div>
        )
    }
}
